export function normalizePatientNameText(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s*,\s*/g, ", ")
    .replace(/\s+/g, " ");
}

export function getPatientNameMatchScore(patient, query) {
  if (!patient || patient.isArchived) return -1;

  const normalizedQuery = normalizePatientNameText(query);
  if (!normalizedQuery) return 0;

  const first = normalizePatientNameText(patient.firstName);
  const last = normalizePatientNameText(patient.lastName);
  const candidates = [
    first,
    last,
    [first, last].filter(Boolean).join(" "),
    [last, first].filter(Boolean).join(" "),
    first && last ? `${last}, ${first}` : last || first,
  ].filter(Boolean);

  if (candidates.some((candidate) => candidate.startsWith(normalizedQuery))) {
    return 0;
  }

  return candidates.some((candidate) => candidate.includes(normalizedQuery)) ? 1 : -1;
}
